export default {

  // 用户列表
  getMemberList(params, success) {
    Request.GET('/user', params, response => success(response));
  },

  // 查询用户详情
  getMemberDetail(id, success) {
    Request.GET(`/user/${id}`, null, response => success(response));
  },

  // 用户积分信息
  getMemberIntegral(params, success) {
    Request.GET('/user/points', params, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/memberApi.js